import React from 'react'
import PropTypes from 'prop-types'
import { colors } from '@lmc/common/constants'
import { SectionHeader } from '../../../../components/generic'
import { Button, Icon } from '@lmc/ui-kit'
import { theme } from '@lmc/ui-kit/src/config/theme'

export const Row = ({ onDelete, timing, index }) => (
  <div style={styles.row} data-testid={`emar-round-timing-row-${index}`}>
    <div style={styles.time} data-testid={`emar-round-timing-time-${index}`}>{timing.time}</div>
    <div style={styles.roundTitle} data-testid={`emar-round-timing-title-${index}`}>
      {timing.title ? (
        timing.title
      ) : (
        <span style={styles.roundTitlePlaceholder}>No round name</span>
      )}
    </div>
    <div style={styles.buttonContainer}>
      <Button
        className="important-contact-delete"
        onClick={() => onDelete(timing.id)}
        variant="danger"
        buttonInnerStyle={{
          backgroundColor: theme.palette.white
        }}
        data-testid={`emar-round-timing-remove-btn-${index}`}
      >
        Remove
      </Button>
    </div>
  </div>
)

Row.propTypes = {
  onDelete: PropTypes.func.isRequired,
  timing: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired
}

export const RoundTimings = ({
  deleteRoundTiming,
  homeName,
  openNewRoundTimingModal,
  roundTimings,
  hideHeader
}) => {
  return (
    <div style={styles.container} data-testid="emar-round-timings-container">
      {!hideHeader && (
        <>
          <div data-testid="emar-round-timings-header">
            <SectionHeader title="Medication Round Times" />
          </div>
          <div data-testid="emar-round-timings-description">
            <span style={styles.preferred_subTitle1}>
              {`Set up the times that ${homeName} does Medication Rounds. This option will appear when you are adding medications to the system. This will help to reduce errors.`}
            </span>
          </div>
        </>
      )}
      <div style={styles.timingsContainer} data-testid="emar-round-timings-list">
        {roundTimings && roundTimings.length
          ? roundTimings.map((timing, index) => (
              <Row
                key={timing.id}
                timing={timing}
                onDelete={deleteRoundTiming}
                index={index}
              />
            ))
          : null}
        <Button
          onClick={openNewRoundTimingModal}
          variant="primary"
          icon={<Icon name="PlusOutlined" />}
          data-testid="emar-add-round-timing-btn"
        >
          Add Medication Round
        </Button>
      </div>
    </div>
  )
}

const styles = {
  container: { paddingBottom: 64 },
  timingsContainer: { paddingTop: 18 },
  row: {
    paddingBottom: 12,
    display: 'flex'
  },
  time: {
    border: `1px solid ${colors.grey}`,
    borderRadius: 4,
    padding: '6px 12px',
    marginRight: 12
  },
  roundTitle: {
    border: `1px solid ${colors.grey}`,
    borderRadius: 4,
    minWidth: 167,
    padding: '6px 12px',
    marginRight: 12
  },
  roundTitlePlaceholder: {
    fontStyle: 'italic',
    color: colors.darkgrey
  },
  buttonContainer: { marginBottom: 2 }
}

RoundTimings.propTypes = {
  roundTimings: PropTypes.array,
  deleteRoundTiming: PropTypes.func,
  openNewRoundTimingModal: PropTypes.func
}

export default RoundTimings
